import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workingday'
})
export class WorkingDayPipe implements PipeTransform {

  transform(value: any): string {
 
    if(value>1){
     return value+ " working days"
    }else{
      return value+ " working day"
    }


  }

}
